import React, { useState } from 'react';

/**
 * ExportDropdown Component
 *
 * Reusable export dropdown button with CSV and Excel options
 * Used across all analytics reports for consistent export functionality
 */

interface ExportDropdownProps {
  onExportCSV?: () => void;
  onExportExcel?: () => void;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({ onExportCSV, onExportExcel }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showNotice, setShowNotice] = useState(false);

  const handleExport = (format: string) => {
    setShowMenu(false);
    if (format === 'csv' && onExportCSV) {
      onExportCSV();
    } else if (format === 'excel' && onExportExcel) {
      onExportExcel();
    } else {
      setShowNotice(true);
      setTimeout(() => setShowNotice(false), 3000);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        style={{
          backgroundColor: '#f3f4f6',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          padding: '0.5rem 1rem',
          fontSize: '0.875rem',
          fontWeight: '500',
          color: '#374151',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem'
        }}
      >
        Export {showMenu ? '\u25B2' : '\u25BC'}
      </button>
      {showMenu && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '0.25rem',
          backgroundColor: '#ffffff',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          zIndex: 50,
          minWidth: '120px'
        }}>
          <button
            onClick={() => handleExport('csv')}
            style={{
              width: '100%',
              textAlign: 'left',
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              color: '#374151',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              borderBottom: '1px solid #e5e7eb'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            CSV
          </button>
          <button
            onClick={() => handleExport('excel')}
            style={{
              width: '100%',
              textAlign: 'left',
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              color: '#374151',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            Excel
          </button>
        </div>
      )}
      {showNotice && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '0.25rem',
          backgroundColor: '#FEF3C7',
          border: '1px solid #F59E0B',
          borderRadius: '4px',
          padding: '0.5rem 0.75rem',
          fontSize: '0.8rem',
          color: '#92400E',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          zIndex: 51
        }}>
          Export will be available once report data is populated.
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
